import * as ROUTES from 'routes';

export const PAGES_WITH_SIDEBAR = [ROUTES.REPORTS, ROUTES.SUPPORT];

export const PRODUCT_PREFIX = 'BSR';
